module.exports = __webpack_public_path__ + "static/media/birmingham_team.2a4821ee.jpg";